import { render, staticRenderFns } from "./SliderPanel.vue?vue&type=template&id=04e78c22&lang=pug&"
import script from "./SliderPanel.vue?vue&type=script&lang=js&"
export * from "./SliderPanel.vue?vue&type=script&lang=js&"
import style0 from "./SliderPanel.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04e78c22')) {
      api.createRecord('04e78c22', component.options)
    } else {
      api.reload('04e78c22', component.options)
    }
    module.hot.accept("./SliderPanel.vue?vue&type=template&id=04e78c22&lang=pug&", function () {
      api.rerender('04e78c22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/SliderPanel.vue"
export default component.exports